import { LockKeyhole } from "lucide-react";
import { type FormEvent, useEffect, useRef, useState } from "react";
import { postJson } from "../api";

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const requestLock = useRef(false);

  useEffect(() => {
    const prevBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "rgb(20, 19, 16)";
    return () => {
      document.body.style.backgroundColor = prevBg;
    };
  }, []);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!password || requestLock.current) return;
    requestLock.current = true;
    setLoading(true);
    setError("");
    try {
      await postJson("/api/auth/login", { password });
      onSuccess();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "登录失败");
    } finally {
      requestLock.current = false;
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-brand"><span className="login-seal" aria-hidden="true">墨</span><span>墨砚</span></div>
        <div className="login-heading">
          <div className="login-lock"><LockKeyhole size={20} /></div>
          <h1>进入创作台</h1>
          <p>使用部署时配置的访问密码</p>
        </div>
        <form onSubmit={submit}>
          <label htmlFor="password">访问密码</label>
          <div className="ux-password-row"><input id="password" type={visible ? "text" : "password"} autoComplete="current-password" value={password} onChange={(event) => { setPassword(event.target.value); setError(""); }} required disabled={loading} aria-invalid={Boolean(error)} aria-describedby={error ? "login-error" : undefined} autoFocus /><button type="button" className="button button-secondary" disabled={loading} aria-pressed={visible} aria-label={visible ? "隐藏密码" : "显示密码"} onClick={() => setVisible((value) => !value)}>{visible ? "隐藏" : "显示"}</button></div>
          {error && <div className="form-error" id="login-error" role="alert">{error}</div>}
          <button className="button button-primary login-submit" type="submit" disabled={loading || !password}>
            {loading && <span className="spinner" />}
            {loading ? "验证中" : "登录"}
          </button>
        </form>
      </section>
    </main>
  );
}
